import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';

@Component({
  selector: 'lib-delete-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  template: `<mat-dialog-content>
      <div class="p-8">
        <p class="text-center text-tb-letter">
          Are you sure you want to delete this
          <strong>{{ data }}</strong
          >?
        </p>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <div class="px-8 py-2 w-full flex justify-around">
        <button
          class="px-8 h-12 bg-transparent rounded-md text-[#4B4B4B] font-bold border-2 border-solid border-[#4B4B4B]"
          (click)="onCancel()"
        >
          Cancel
        </button>
        <button
          class="px-8 h-12 border-2 border-solid border-red-600 font-bold rounded-md bg-red-600 text-white"
          (click)="onConfirm()"
        >
          Delete
        </button>
      </div>
    </mat-dialog-actions>`,
  styles: [
    `
      ::ng-deep {
        .mat-mdc-dialog-surface {
          border-radius: 15px !important;
          background-color: #fafafa !important;
        }
        .mat-mdc-dialog-container-with-actions .mat-mdc-dialog-content {
          overflow-x: hidden !important;
          padding: unset !important;
        }
      }
    `,
  ],
})
export class DeleteDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<DeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string
  ) {}

  onConfirm() {
    this.dialogRef.close('confirm');
  }

  onCancel() {
    this.dialogRef.close('cancel');
  }
}
